import { deserialize } from 'libs/cerialize';

export class PreviewDocumentModel {
	@deserialize
	FileName: string;

	@deserialize
	FileType: string;

	@deserialize
	Content: string;

	@deserialize
	IsWebDocument: boolean;
	OpenedOnDesktop: boolean;

	// Filled by the document manager rather than the server: when Collabora renders
	// the preview these name the session it opened, and no Content is sent at all.
	CollaboraSrc: string;

	CollaboraToken: string;

	// An editable session rather than a read-only one: the viewer then offers a
	// Save, and saving posts the session back to the platform.
	CollaboraFileId: string;

	IsCollaboraEditable: boolean;
}